module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nprogress-container"
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-25953fa2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-nprogress/src/NprogressContainer.vue
// module id = 350
// module chunks = 143